import { useMemo } from 'react';

import { themeObjectToString, themeStringToObject } from '@atlaskit/tokens';

import { fg } from '@confluence/feature-gating';
import { useThemingService } from '@confluence/whiteboard-common';

import {
	EMBEDDED_THEME_STATE,
	PARENT_PRODUCT_QUERY_PARAM,
	PARENT_PRODUCT_SMART_LINK,
} from '../database-params';

export const useInitialUrl = ({
	version,
	isSmartLinkEmbed,
	versionId,
}: {
	version?: string;
	isSmartLinkEmbed?: boolean;
	versionId?: string | null;
}) => {
	const { initialThemeSerialized } = useThemingService();

	return useMemo(() => {
		const url = new URL(`/databases/standalone`, window.location.origin);
		if (version) {
			url.searchParams.set('bifrost-override', version);
		}

		if (isSmartLinkEmbed) {
			url.searchParams.set(PARENT_PRODUCT_QUERY_PARAM, PARENT_PRODUCT_SMART_LINK);
		}

		if (initialThemeSerialized) {
			const themeObject = themeStringToObject(initialThemeSerialized);
			url.pathname = `${url.pathname}/${themeObject.colorMode === 'dark' ? 'index-dark.html' : 'index.html'}`;
			url.searchParams.set(
				EMBEDDED_THEME_STATE,
				encodeURIComponent(themeObjectToString(themeObject)),
			);
		}

		if (versionId && fg('confluence_frontend_databases_version_history_ui')) {
			url.searchParams.set('version', versionId);
		}

		const finalUrlParts = [url.pathname];
		if (Array.from(url.searchParams).length > 0) {
			finalUrlParts.push(url.searchParams.toString());
		}

		return finalUrlParts.join('?');
	}, [version, isSmartLinkEmbed, initialThemeSerialized, versionId]);
};
